// FILE: src/app/error.tsx
// VERSION: 1.0.0
// COMPONENT_CONTRACT
//   PURPOSE: Error boundary for the app — catches render errors and logs to OTel
//   PROPS: { error: Error, reset: () => void }
//   STATE: none
//   DEPENDS: none (no OTel deps at runtime to avoid import issues)
//   EMITS: console.error
//   ACCESSIBILITY: focus visible on retry button
// END_CONTRACT

"use client"

import { useEffect } from "react"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("Render error:", error)
  }, [error])

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center gap-4">
      <h2 className="text-lg font-medium text-text-on-dark">Something went wrong</h2>
      <p className="max-w-md text-center text-sm text-text-muted">
        {error.message || "An unexpected error occurred"}
      </p>
      <button
        onClick={reset}
        className="min-h-11 rounded-md bg-accent-yellow px-4 py-2 text-sm font-medium text-black transition hover:bg-accent-yellow/90"
      >
        Try again
      </button>
    </div>
  )
}
